<script>
  const DEFAULT_INITIALISM = "ind";

  let showroom, pickedTypesAbbr;

  import { Link } from "svelte-routing";

  import * as typologies from "../configs/typologies.json";

  import MiniCard from "../ponents/MiniCard.svelte";
  import ArchetypicalCharactersCard from "../ponents/ArchetypicalCharactersCard.svelte";
  import { getStats } from "../ponents/ArchetypicalCharactersCard.svelte";

  var modal;

  import { onMount } from "svelte";

  import { adsConfig } from "../stores/Store";

  onMount(() => {
    modal = new bootstrap.Modal(document.getElementById("modal"));

    adsConfig.set({
      footerBanner: true,
      interstitial: false,
    });
  });

  function popExpandedCard(abbr) {
    pickedTypesAbbr = abbr;
    modal.show();
  }

  import * as broadClasses from "../configs/broadClasses.json";
  const broadClassesList = broadClasses.default;

  import { sum } from "../global";

  import { onDestroy } from "svelte";

  onDestroy(() => {
    modal.hide();
  });

  import SelectedGender from "../stores/Persistent";
  import GenderSelect from "../ponents/GenderSelect.svelte";
</script>

<svelte:head>
  <title>Archetypes’ Catalog · 27types</title>
</svelte:head>

<header>
  <section>
    <Link to="/">
      <button class="btn btn-primary shadow-sm"
        >Take The <em>27types</em> Test</button
      >
    </Link>
    <Link to="/statistics">
      <button class="btn btn-info shadow-sm">Explore Statistics</button>
    </Link>
  </section>
  <section>
    <h1><em>27types</em>’s Archetypes</h1>
  </section>
  <section>
    <GenderSelect></GenderSelect>
  </section>
</header>
<main>
  {#each broadClassesList as broadClass}
    <section>
      <h2>{broadClass.label}</h2>
      {#each Object.entries(typologies.default) as [abbreviation, longName]}
        {@const statsDict = getStats(abbreviation)}
        {@const scoreSum = sum(Object.values(statsDict))}
        {#if broadClass.min <= scoreSum && scoreSum <= broadClass.max}
          <MiniCard
            abbr={abbreviation}
            gender={$SelectedGender}
            on:click={() => {
              popExpandedCard(abbreviation);
            }}
          />
        {/if}
      {/each}
    </section>
  {/each}
</main>
<!-- Full screen modal -->
<div class="modal fade" tabindex="-1" id="modal">
  <div class="modal-dialog modal-fullscreen">
    <div class="container centerer">
      {#key pickedTypesAbbr}
        <ArchetypicalCharactersCard
          abbr={pickedTypesAbbr ?? DEFAULT_INITIALISM}
          bind:this={showroom}
        />
      {/key}
    </div>
  </div>
</div>

<style>
  main {
    text-align: center;
    /*margin-bottom: 2.5rem;*/
  }
  .container.centerer {
    display: flex;
    min-height: 100%;
    flex-direction: column;
    align-items: stretch;
    justify-content: center;
  }
  h2 {
    margin: 0 0 1rem 0;
  }
</style>
